import React from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import StoreCard from '../StoreCard';

const StoreCards = ({ stores }) => {
    return (
        <Grid 
            w='100%' spacing='24px'
            templateRows={{
                base: 'repeat(4, 1fr)',
                sm: 'repeat(2, 1fr)',
                lg: 'repeat(1, 1fr)',
            }}
            templateColumns={{
                base: 'repeat(4, 1fr)',
                sm: 'repeat(4, 1fr)',
                lg: 'repeat(4, 1fr)',
            }}
            gap={4}
        >
            <GridItem colSpan={{
                base: 4,
                md: 2,
                lg: 1,
            }}>
                <StoreCard flex={1} />
            </GridItem>
            <GridItem colSpan={{
                base: 4,
                md: 2,
                lg: 1,
            }}>
                <StoreCard flex={1} />
            </GridItem>
            <GridItem colSpan={{
                base: 4,
                md: 2,
                lg: 1,
            }}>
                <StoreCard flex={1} />
            </GridItem>
            <GridItem colSpan={{
                base: 4,
                md: 2,
                lg: 1,
            }}>
                <StoreCard flex={1} />
            </GridItem>
        </Grid>
    )
}

export default StoreCards;